<template>
  <div
    class="modal fade"
    id="importerManagementModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            aria-hidden="true"
            @click="closeModal"
            :disabled="isImporterEditing"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.IMP000 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="panel-body">
            <div class="form-group col-md-12">
              <label for="inputNewImporter" class="col-md-2 control-label">{{
                lang.IMP001
              }}</label>
              <div class="col-md-7">
                <input
                  id="inputNewImporter"
                  type="text"
                  class="form-control"
                  v-model="newImporter"
                  @keydown.enter="addNewImporter()"
                />
              </div>
              <button
                id="importer-modal-add-button"
                type="button"
                class="btn btn-raised dialog-btn-primary"
                style="margin-top: 0px"
                :disabled="!newImporter || isImporterEditing"
                @click="addNewImporter()"
              >
                {{ lang.IMP002 }}
              </button>
            </div>

            <div id="importersTableContainer" class="col-md-12">
              <table
                class="table table-striped table-hover"
                id="importersTable"
              >
                <thead>
                  <tr>
                    <th class="text-center col-md-10">{{ lang.IMP003 }}</th>
                    <th class="text-center col-md-2">{{ lang.IMP004 }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    role="button"
                    v-for="(importer, index) in importerList"
                    :key="index"
                    :class="{ info: importer.editing }"
                  >
                    <td class="nopadding">
                      <div class="form-group nopadding">
                        <input
                          type="text"
                          class="form-control text-center nopadding"
                          readonly="true"
                          @dblclick="
                            importer.ImporterGuid ===
                              '1D86A788-07D6-4681-BD8C-9C15800DF8BA' ||
                              editImporter($event, importer)
                          "
                          @blur="
                            importer.ImporterName !==
                              importer.prevImporterName ||
                              undoImporterChanges($event, importer)
                          "
                          v-model="importer.ImporterName"
                        />
                      </div>
                    </td>
                    <td class="nopadding" id="importerActionButtonContainer">
                      <template
                        v-if="
                          importer.ImporterGuid !==
                          '1D86A788-07D6-4681-BD8C-9C15800DF8BA'
                        "
                      >
                        <button
                          id="importer-action-button-container-edit"
                          type="button"
                          class="btn"
                          @click="editImporter($event, importer)"
                          v-show="!importer.editing"
                          :disabled="isImporterEditing"
                        >
                          <i class="material-icons md-24">edit</i>
                        </button>
                        <button
                          type="button"
                          class="btn"
                          @click="saveImporter($event, importer)"
                          v-show="importer.editing"
                        >
                          <i class="material-icons md-24 text-primary">save</i>
                        </button>
                        <button
                          type="button"
                          class="btn"
                          @click="deleteImporter(importer)"
                          v-show="!importer.editing"
                          :disabled="isImporterEditing"
                        >
                          <i class="material-icons md-24 text-red">clear</i>
                        </button>
                        <button
                          type="button"
                          class="btn"
                          @click="undoImporterChanges($event, importer)"
                          v-show="importer.editing"
                        >
                          <i class="material-icons md-24 text-primary">undo</i>
                        </button>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised"
            @click="closeModal"
            :disabled="isImporterEditing"
          >
            {{ lang.IMP005 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImporterManagement",
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newImporter: "",
      importerList: [],
      isImporterEditing: false,
      lang: {
        IMP000: "Importers",
        IMP001: "New importer",
        IMP002: "Add",
        IMP003: "Importer",
        IMP004: "Actions",
        IMP005: "Close",
        IMP006: "Importer list access failed",
        IMP007: "Importer name already exists",
        IMP008: "Importer creation successful",
        IMP009: "Importer creation failed",
        IMP010: "Importer update successful",
        IMP011: "Importer update failed",
        IMP012: "Importer deletion successful",
        IMP013: "Importer deletion failed",
        IMP014: "Delete Importer",
        IMP015: "Yes",
        IMP016: "No",
        IMP017: "Do you really want to delete the following importer?",
        IMP018: "Empty importer name not allowed",
      },
    };
  },
  watch: {
    showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#importerManagementModal").on("hidden.bs.modal", (e) => {
      this.$emit("modalClosed");
    });
  },
  methods: {
    openModal() {
      this.newImporter = "";
      this.isImporterEditing = false;
      this.getImporterList();
      $("#importerManagementModal").modal("show");
    },
    closeModal() {
      this.globals.importerList = [];
      $("#importerManagementModal").modal("hide");
    },
    getImporterList() {
      $.ajax({
        method: "GET",
        url: `api/Importer`,
        success: (data) => {
          this.importerList = [];
          if (!_.isEmpty(data)) {
            this.importerList = data;
            let internationalImporter = _.remove(
              this.importerList,
              (importer) =>
                importer.ImporterGuid === "1D86A788-07D6-4681-BD8C-9C15800DF8BA"
            );
            if (internationalImporter[0])
              this.importerList.unshift(internationalImporter[0]);
          }
        },
        error: () => {
          console.error("Importer list access failed in getImporterList()");
          this.globals.showErrorSnackbar(this.lang.IMP006);
        },
      });
    },
    addNewImporter() {
      $("#inputNewImporter").focus();
      if (!this.newImporter || this.isImporterEditing) return;
      if (
        _.findIndex(
          this.importerList,
          (i) => i.ImporterName === this.newImporter
        ) > -1
      ) {
        this.globals.showErrorSnackbar(this.lang.IMP007);
        return;
      }
      let postData = {
        ImporterName: this.newImporter,
      };
      $.ajax({
        method: "POST",
        url: `api/Importer`,
        data: JSON.stringify(postData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.importerList.unshift(data);
          this.globals.showSuccessSnackbar(this.lang.IMP008);
          this.newImporter = "";
        },
        error: () => {
          console.error("Error on POST in addNewImporter()");
          this.globals.showErrorSnackbar(this.lang.IMP009);
        },
      });
    },
    updateImporter(importer) {
      $.ajax({
        method: "PUT",
        url: `api/Importer/${importer.ImporterGuid}`,
        data: JSON.stringify(importer),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.globals.showSuccessSnackbar(this.lang.IMP010);
        },
        error: () => {
          console.error("Error on PUT in updateImporter()");
          this.globals.showErrorSnackbar(this.lang.IMP011);
        },
      });
    },
    deleteImporter(importer) {
      if (this.isImporterEditing) return;

      this.globals.$off("DeleteImporterYesConfirmation");
      this.globals.$on("DeleteImporterYesConfirmation", () => {
        $.ajax({
          method: "DELETE",
          url: `api/Importer/${importer.ImporterGuid}`,
          success: (data) => {
            _.remove(
              this.importerList,
              (i) => i.ImporterGuid === importer.ImporterGuid
            );
            this.$forceUpdate();
            this.globals.showSuccessSnackbar(this.lang.IMP012);
          },
          error: () => {
            console.error("Error on DELETE in deleteImporter()");
            this.globals.showErrorSnackbar(this.lang.IMP013);
          },
        });
      });

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "DeleteImporter",
        confirmationTitle: this.lang.IMP014,
        colorRed: true,
        yesButtonText: this.lang.IMP015,
        noButtonText: this.lang.IMP016,
        htmlText: `<p>${this.lang.IMP017}</p>
                  <p><b>${importer.ImporterName}</b></p>`,
      });
    },
    editImporter(e, importer) {
      if (this.isImporterEditing) return;
      importer.editing = true;
      this.isImporterEditing = true;
      importer.prevImporterName = importer.ImporterName;
      let input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "");
      input.focus();
    },
    saveImporter(e, importer) {
      let input = $(e.target).closest("tr").find("input");

      if (!importer.ImporterName) {
        this.globals.showErrorSnackbar(this.lang.IMP018);
        input.focus();
        return;
      }

      let count = _.filter(
        this.importerList,
        (i) => i.ImporterName === importer.ImporterName
      ).length;
      if (count > 1) {
        this.globals.showErrorSnackbar(this.lang.IMP007);
        input.focus();
        return;
      }

      this.isImporterEditing = false;
      delete importer.editing;
      delete importer.prevImporterName;
      input.prop("readonly", "true");
      this.updateImporter(importer);
    },
    undoImporterChanges(e, importer) {
      let input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "true");
      this.isImporterEditing = false;
      delete importer.editing;
      importer.ImporterName = importer.prevImporterName;
      delete importer.prevImporterName;
    },
  },
};
</script>

<style scoped>
#importersTableContainer {
  max-height: calc(100vh - 270px);
  overflow: auto;
  padding: 0;
  border: 1px solid lightgray;
}

#importersTable input:read-only {
  cursor: pointer;
  background-image: none !important;
}

#importerActionButtonContainer > .btn {
  padding: 0px;
  margin: 7px;
}
</style>



// WEBPACK FOOTER //
// ImporterManagement.vue?3ccbd7d8